import { MeloAttributeEntry, MeloAttributeItem } from '../jobs/jobs.types';

export const types = {
    CREATE_MELO_ATTRIBUTE: 'CREATE_MELO_ATTRIBUTE',
    UPDATE_MELO_ATTRIBUTE: 'UPDATE_MELO_ATTRIBUTE',
    DELETE_MELO_ATTRIBUTE: 'DELETE_MELO_ATTRIBUTE',
    MELO_ATTRIBUTE_SAVE_DONE: 'MELO_ATTRIBUTE_SAVE_DONE',
    MELO_ATTRIBUTE_SAVE_ERROR: 'MELO_ATTRIBUTE_SAVE_ERROR',
    MELO_ATTRIBUTE_RESET_STATUS: 'MELO_ATTRIBUTE_RESET_STATUS',
    MELO_ATTRIBUTE_UPSERTED: 'MELO_ATTRIBUTE_UPSERTED',
    MELO_ATTRIBUTE_REMOVED: 'MELO_ATTRIBUTE_REMOVED',
};

const createMeloAttribute = (accountId: string, meLoId: string, entry: MeloAttributeEntry) =>
    ({ type: types.CREATE_MELO_ATTRIBUTE, accountId, meLoId, entry });
const updateMeloAttribute = (accountId: string, meLoId: string, attributeId: string, entry: MeloAttributeEntry, version: number) =>
    ({ type: types.UPDATE_MELO_ATTRIBUTE, accountId, meLoId, attributeId, entry, version });
const deleteMeloAttribute = (accountId: string, meLoId: string, attributeId: string) =>
    ({ type: types.DELETE_MELO_ATTRIBUTE, accountId, meLoId, attributeId });
const saveDone = () => ({ type: types.MELO_ATTRIBUTE_SAVE_DONE });
const saveError = (conflict = false, stale = false) => ({ type: types.MELO_ATTRIBUTE_SAVE_ERROR, conflict, stale });
const resetStatus = () => ({ type: types.MELO_ATTRIBUTE_RESET_STATUS });
const meloAttributeUpserted = (meLoId: string, item: MeloAttributeItem) =>
    ({ type: types.MELO_ATTRIBUTE_UPSERTED, meLoId, item });
const meloAttributeRemoved = (meLoId: string, attributeId: string) =>
    ({ type: types.MELO_ATTRIBUTE_REMOVED, meLoId, attributeId });

export default {
    createMeloAttribute,
    updateMeloAttribute,
    deleteMeloAttribute,
    saveDone,
    saveError,
    resetStatus,
    meloAttributeUpserted,
    meloAttributeRemoved,
};
